import type { InterludeTypes } from "@/interlude";

// Service-account orgs lose access when someone removes our account from
// their MCC, which re-authorizing cannot fix, so only OAuth orgs get the prompt.
export const needsReauthorization = (
  managerAccount: Pick<
    InterludeTypes["GoogleAdsManagerAccount"],
    "authType" | "hasAccess"
  >,
): boolean =>
  managerAccount.authType === "oauth" && managerAccount.hasAccess === false;
